import React from 'react'
import LeftNavBar from '../components/LeftNavBar'

const NavigationBarLayout = props => {
    return (
        <div style={{ display: 'flex', width: '100%', height: '100vh' }}>
            <LeftNavBar activeSegment={props.activeSegment} />          
            <main style={{ flex: 1, padding: '10px 40px', display: 'flex', flexDirection: 'column', alignItems: 'flex-start', margin: '0px 0px 30px 284px' , overflow: 'auto'}}>
                {props.children}
            </main>
        </div>
    )
}

export default NavigationBarLayout